// import router from '@/router'
// import moment from 'moment'
// import store from '@/store'
/* --  Default Configuration for Bar Charts  (options) -- */
export const regularBarChartConfiguration = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
          callback: function (value, index, values) {
            if (value) {
              return value.toLocaleString('de', {
                style: 'currency',
                currency: 'EUR'
              })
            }
          }
        },
        gridLines: { display: true }
      }
    ],
    xAxes: [{ ticks: { beginAtZero: true }, gridLines: { display: true } }]
  },
  tooltips: {
    enabled: true,
    filter: function (tooltipItem, data) {
      let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
      if (!value) {
        return false
      } else {
        return true
      }
    },
    callbacks: {
      label: (tooltipItems, data) => {
        return tooltipItems.yLabel.toLocaleString('de', {
          style: 'currency',
          currency: 'EUR'
        })
      }
    }
  }
}
// tooltips : index => muestra todos los datos de la columna entera con las agrupacioens
export const stackedBarChartConfiguration = {
  responsive: true,
  maintainAspectRatio: false,
  legend: {
    display: false
  },
  // onClick: function (event, array) {
  //   const chartIndex = this.getElementAtEvent(event)
  //   // If found, returns an array with the chartelement
  //   if (chartIndex.length !== 0) {
  //     const dataSetIndex = chartIndex[0]._datasetIndex
  //     const position = chartIndex[0]._index
  //     const dataFromClickedElement = chartIndex[0]._chart.tooltip._data.datasets[dataSetIndex]
  //     const dateFromClickedElement = dataFromClickedElement.dates[position]
  //     let transactionQueries = {
  //       'date[after]': moment(dateFromClickedElement).format()

  //     }
  //     const expenseGroupByFilter = store.getters['DashboardStore/expenseDataFilters'].groupBy
  //     if (expenseGroupByFilter === 'month') {
  //       transactionQueries['date[before]'] = moment(dateFromClickedElement).endOf('month').format()
  //     } else {
  //       transactionQueries['date[before]'] = moment(dateFromClickedElement).endOf('day').format()
  //     }

  //     if (dataFromClickedElement.dataType === 'BUDGET') {
  //       if (dataFromClickedElement.id) {
  //         transactionQueries['budget.id'] = dataFromClickedElement.id
  //       } else {
  //         transactionQueries['type.code'] = 'EXPENSE'
  //       }
  //     }

  //     if (dataFromClickedElement.dataType === 'CATEGORY') {
  //       if (dataFromClickedElement.id) {
  //         transactionQueries['customCategory.defaultCategoryOffice.id'] = dataFromClickedElement.id
  //       } else {
  //         transactionQueries['exists[customCategory.defaultCategoryOffice]'] = false
  //       }
  //     }

  //     router.push({
  //       name: 'transactions_charged',
  //       query: { ...transactionQueries }
  //     })
  //   }
  // },

  tooltips: {
    mode: 'index',

    filter: function (tooltipItem, data) {
      let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
      if (!value) {
        return false
      } else {
        return true
      }
    },

    callbacks: {
      label: function (tooltipItem, data) {
        var label = data.datasets[tooltipItem.datasetIndex].label || ''

        if (label) {
          label += ': '
        }
        label += tooltipItem.yLabel.toLocaleString('de', {
          style: 'currency',
          currency: 'EUR'
        })
        return label
      },
      title: function (tooltipItems, data) {
        let tooltipSum = tooltipItems.reduce((acc, current) => {
          return Number.parseFloat(acc) + Number.parseFloat(current.value)
        }, 0)
        const formatter = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })
        return `${tooltipItems[0].label}: ${formatter.format(tooltipSum)}`
      }

    }
  },
  scales: {
    yAxes: [
      {
        stacked: true,
        ticks: {
          beginAtZero: true
        }
      }
    ],
    xAxes: [
      {
        stacked: true,
        ticks: {
          beginAtZero: true
        }
      }
    ]
  }
}

export const testData = {
  labels: ['ENERO', 'FEBRERO', 'MARZO'],
  datasets: [
    {
      label: 'COLUMNA 1',
      data: [20, 30],
      backgroundColor: '#4287f5'
    },
    {
      label: 'COLUMNA 2',
      data: [40],
      backgroundColor: '#00f2ba'
    },
    {
      label: 'COLUMNA 3',
      data: [70, 80, 90],
      backgroundColor: ''
    }
  ]
}

export const notStackableData = {
  labels: ['ENERO', 'FEBRERO', 'MARZO'],
  datasets: [
    {
      label: 'COLUMNA 1',
      data: [30, 36, 23],
      backgroundColor: '#4287f5'
    }
  ]
}
